import { Country, Workshop } from "../../../shared/types";
import { sanitizeImgUrls } from "../helpers/functions";
import { get, GetAllResponse, GetResponse, post, put, remove } from "./_base";

const path = "workshops";

const sanitizeWorkshop = (
  response: GetResponse<Workshop>
): GetResponse<Workshop> => {
  return {
    ...response,
    data: sanitizeWorkshopData(response.data),
  };
};

const sanitizeWorkshopData = (data: Workshop): Workshop => {
  return {
    ...data,
    image: {
      ...data.image,
      path: sanitizeImgUrls(data.image.path),
    },
    text: sanitizeImgUrls(data.text),
  };
};

const sanitizeWorkshops = (
  response: GetAllResponse<Workshop>
): GetAllResponse<Workshop> => {
  return {
    ...response,
    data: response.data.map(sanitizeWorkshopData),
  };
};
export class WorkshopActions {
  static post = async (data: Workshop) => {
    return await post(path, data);
  };

  static get = async (data: Partial<Workshop | Pick<Country, "code">>) => {
    const response = (await get(path, data, {
      single: true,
    })) as GetResponse<Workshop>;

    return sanitizeWorkshop(response);
  };
  static getForOwner = async (data: Partial<Workshop>) => {
    const response = (await get(`${path}/owner`, data, {
      single: true,
    })) as GetResponse<Workshop>;

    return sanitizeWorkshop(response);
  };
  static getForBack = async (data: Partial<Workshop>) => {
    const response = (await get(`${path}/back`, data, {
      single: true,
    })) as GetResponse<Workshop>;

    return sanitizeWorkshop(response);
  };
  static getAll = async (data: Partial<Workshop | Pick<Country, "code">>) => {
    const response = (await get(path, data)) as GetAllResponse<Workshop>;

    return sanitizeWorkshops(response);
  };
  static getAllForOwner = async (data: Partial<Workshop>) => {
    const response = (await get(
      `${path}/owner`,
      data
    )) as GetAllResponse<Workshop>;

    return sanitizeWorkshops(response);
  };
  static getAllForBack = async (data: Partial<Workshop>) => {
    const response = (await get(
      `${path}/back`,
      data
    )) as GetAllResponse<Workshop>;

    return sanitizeWorkshops(response);
  };
  static put = async (data: Workshop) => {
    return await put(path, data);
  };
  static remove = async (id: string) => {
    return await remove(path, id);
  };
}
